module.exports = __webpack_public_path__ + "img/light.38aa4c10.png";